import { SHOW_ALERT, HIDE_ALERT } from 'actions';

const initState = {
  alert: {
    position: 'tc',
    show: false,
    message: 'Hello world',
    color: 'info', // info, success, warning, danger, primary, rose,
  }
}

export default function (state = initState, action) {
  switch (action.type) {

    case SHOW_ALERT: {
      return {
        ...state,
        alert: {
          ...state.alert,
          ...action.payload,
          show: true,
        }
      }
    }

    case HIDE_ALERT: {
      return {
        ...state,
        alert: {
          ...state.alert,
          show: false,
        }
      }
    }

    default:
      return state
  }
}